// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3rqAt","footer":"ModalFilter_footer__1I4pS"};